import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/horizontalSquare.constants';

export * from './customer/default/horizontalSquare.constants';

export const templates = {
  HorizontalSquare: 'HorizontalSquare',
};

export const heights = {
  [HD]: 164,
  [FULL_HD]: 200,
};

export const imageOptions = {
  [templates.HorizontalSquare]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: 120,
          height: 120,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: 144,
          height: 144,
        },
      },
    },
  },
};

const { sizes: elementSizes } = getElementSize(ITEMS_BY_BREAKPOINTS, 1.0, templates.HorizontalSquare);

const buildSizes = context =>
  [FULL_HD, HD].reduce(
    (acc, size) => ({
      ...acc,
      [size]: {
        w: elementSizes[templates.HorizontalSquare][context][size].w,
        h: heights[size],
      },
    }),
    {},
  );

export const sizes = {
  [templates.HorizontalSquare]: {
    [RENDERING_CONTEXT.GENERAL]: buildSizes(RENDERING_CONTEXT.GENERAL),
    [RENDERING_CONTEXT.SEARCH]: buildSizes(RENDERING_CONTEXT.SEARCH),
  },
};
